module.exports = __webpack_public_path__ + "static/img/sv-2.f0f59f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/sv-2.jpg
// module id = wS0V
// module chunks = 0